import React, { useEffect, useState } from 'react';
import Head from 'next/head';
import Layout from 'common/components/layout';
import Breadcrumbs from 'common/components/cards/Breadcrumbs-Card';
import PostDetail from 'modules/help/components/FaqDetail';
import { useHelpContext } from 'common/context/help-context';
import { useRouter } from 'next/router';
import useHttp from 'common/hooks/useHttp';
import { baseApiUrl } from 'common/utils/constants';
import { GetServerSideProps, GetServerSidePropsContext } from 'next';

const Question = ({ data }: { data: FAQ }) => {
  const HelpCtx = useHelpContext();
  const { query } = useRouter();
  const { loading, sendRequest } = useHttp();
  const [hasLayout, setHasLayout] = useState<boolean>(true);

  useEffect(() => {
    if (query.header === '0') setHasLayout(false);
  }, [query.header]);

  useEffect(() => {
    if (!HelpCtx?.categories) fetchCategories();
  }, [HelpCtx?.categories]);

  const fetchCategories = async () => {
    sendRequest({ url: `/categories?type=faq` }, onSuccessFetchCategories);
  };

  const onSuccessFetchCategories = (res: Responsive) => {
    HelpCtx?.handleCategories(res.data.items);
  };

  return (
    <>
      <Head>
        <title>{data?.title || 'Category Title'}- Apollon</title>
        <meta name='description' content={data?.shortDescription} />
      </Head>
      <Layout showFooter={hasLayout} showHeader={hasLayout}>
        <Breadcrumbs
          links={[
            {
              title: 'Help Centre',
              href: '/help/categories',
            },
            {
              title: data?.category?.title || 'Category Faq',
              href: '/help/categories/' + data?.category?.id,
            },
            { title: data?.title || 'Title Faq' },
          ]}
        />
        <PostDetail data={data} />
      </Layout>
    </>
  );
};

export default Question;

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  const { id } = context.params!;
  try {
    const res = await fetch(baseApiUrl + `/posts/` + id);
    const data = await res.json();

    if (!data || !data.data) {
      throw new Error('Data is empty');
    }

    // Pass data to the page via props
    return { props: { data: data.data } };
  } catch (error) {
    console.error('Failed to fetch data:', error);
    return { props: { data: {} } }; // Fallback to an empty array in case of error
  }
};
